export default __webpack_public_path__ + "static/media/x.7e2a977d.svg";